import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { UserModel } from '../models/user.model';

export class UserPasswordsApiService extends ApiService {
  static endpoint = 'users/{user_id}/password';

  /**
   * @param {number | null} userId
   * @returns {string}
   * @protected
   */
  static buildUserPasswordUrl(userId) {
    return this.buildUrl().replace('{user_id}', userId);
  }

  /**
   * @param {string | number} userId
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static put(userId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.put(this.buildUserPasswordUrl(userId), data, {
      ...config,
      dataModel: UserModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
